import React, { Component } from "react";
import RepackagingLogo from "../../../Graphics/RepackagingLogo";
import Service from "../../../Service/Service";
import packaging from "../../../../../media/reduced-images/boxes.jpg";

class Repackaging extends Component {
  render() {
    return (
      <Service
        logo={<RepackagingLogo />}
        image={packaging}
        title="Repackaging"
        description="We can transfer your products from bulk to small packaging or
        visa versa; bags to drums, supersacks to cartons. You name it."
      />
    );
  }
}

export default Repackaging;
